import { useLocalStorage } from "usehooks-ts";

export const useOptionalLocalStorage = <T>(
  key: string | undefined,
  initial: T,
) => {
  if (!key) {
    return [initial, () => {}] as const;
  }

  return useLocalStorage(key, initial);
};
